import styled from 'styled-components';
import { TextLabel } from '../../Text';
import { MIN_PC_S_BODY_WIDTH } from '../../../constants/StylistConstants';

const UploadReferencedLook = () => {
  return (
    <Container>
      <TextLabel fontWeight={300}>details</TextLabel>
      <Details>
        This functionality is not available on the demo page. <br />
        <br />
        We will implement it in further releases.
      </Details>
    </Container>
  );
};

const Container = styled.div`
  margin: auto;
  width: 85%;
`;

const Details = styled.div`
  margin-top: 25px;
  margin-bottom: 50px;
  border: 1px solid #000000;
  padding: 40px;

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    margin-top: 15px;
    padding: 20px;
  }
`;

export default UploadReferencedLook;
